module.exports = __webpack_public_path__ + "img/video_1_splash.81281657.jpg";